import { AdminMedicineModel } from "./adminMedicineModel";

export class MedicineGridModel {
    public medicines: Array<AdminMedicineModel>;
    public totalRecordsCount: number;
}